import { useMemo } from 'react';
import { useGetSinglePage } from 'react-easyrocket';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { CONTENT_PAGES } from 'src/constants/contentPages';

const DEFAULT_DESCRIPTION =
  'Find the best casino games all in one place. ⭐ Play the hottest slots, card games, and table games for free online. Enjoy the thrill of real money gaming with no risk and get rewarded with bonuses and promotions.';

export const PageHeadSEO = () => {
  const { childs } = useGetSinglePage(CONTENT_PAGES.SEO);
  const { pathname } = useLocation();

  const seoPageData = useMemo(() => {
    const path = pathname === '/' ? '/main' : pathname;
    return childs?.find((child) => path.includes(child.code));
  }, [childs, pathname]);

  return (
    <Helmet>
      {seoPageData?.keywords && <title>{seoPageData.keywords}</title>}
      <meta name="description" content={seoPageData?.description || DEFAULT_DESCRIPTION} />
      {seoPageData && pathname && <link rel="canonical" href={pathname} />}
    </Helmet>
  );
};
